import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=56a14985&scoped=true"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"
import style0 from "./NavigationPanel.vue?vue&type=style&index=0&id=56a14985&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a14985",
  null
  
)

export default component.exports